import { render, staticRenderFns } from "./RegularRequestV2.vue?vue&type=template&id=67ec4244&"
import script from "./RegularRequestV2.vue?vue&type=script&lang=js&"
export * from "./RegularRequestV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports